

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../../layouts";
import { ScreenSetup } from "../../../components/RoleManagement/ScreenSetup";


export const ScreenSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Screen Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Screen", navigateTo: "/role-management/screen" }
      ]}
      mainContents={<ScreenSetup />}
    />
  );
};
